import { Injectable } from '@angular/core';
import { CommonapiService } from './Commonapi.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { GlocationService } from './Glocation.service';
import { LocationInfoService } from '../Component/LocationInfo/LocationInfo.service';
import { data } from 'jquery';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class CustomerapiService {


  constructor(private router: Router, private api: CommonapiService, private GLS: GlocationService,
    private locationinfo: LocationInfoService) { }
  location: any = "";
  async getLocation(callbackid = "", data = {}) {
    //this.loopcount = 0;
    this.api.loader.startLoading();
    this.location = "";
    this.location = await this.getStartLocation(callbackid, data);
    //console.log(" Success this.location", this.location)
    if (this.location.status = 1 && this.location.lat != undefined && this.location.long != undefined && this.location.lat != 0 && this.location.long != 0) {
      this.location.status = 1;
    } else {
      this.location.status = 0;
    }
    // setTimeout(() => {
    this.api.loader.stopLoading();
    //   });
    return this.location;
  }
  async getStartLocation(callbackid = "", sdata = {}) {

    let _location: any = "";
    await this.GLS.getLocation().then(async (data) => {
      //console.log("waiting data",data)
      _location = data;

      //
    })
    //let _location:any = await this.GLS.getLocation();

    if (_location.status != 1) {
      this.locationinfo.Show({ callbackid: callbackid, sdata: sdata })
    }
    return _location;
    // console.log(" this.location 1", _location)
    // if (_location _location && _location.lat != undefined && _location.long != undefined && _location.lat != 0 && _location.long != 0) {
    //   this.api.loader.stopLoading();this.loopcount =0;
    //   console.log
    //   return   _location;
    // }
    // else {
    //   console.log("this.loopcount",this.loopcount)
    //   if (this.loopcount == 30) { 
    //     //this.api.Logout(); 

    //     this.api.loader.stopLoading(); }
    //   else {
    //     if (this.loopcount == 20) { console.log("Please provide location access"); this.api.Toast_alert("Please provide location access", true); }
    //     this.loopcount = this.loopcount + 1;
    //     setTimeout(async () => { await this.getStartLocation(); }, 1000);
    //   }
    // }
  }






  VerifyDistance(customerID, selectedlat, selectedlong) {

    ///TrignometryDistanceKm
    var TrigonometryDistancekm = this.TrigonometryDistanceFromLatLonInKm(this.location.lat, this.location.long, selectedlat, selectedlong);
    console.log('Trigonometrykm: ', TrigonometryDistancekm);

    var TrigonometryDistanceMeter = TrigonometryDistancekm * 1000;
    return TrigonometryDistanceMeter;


  }

  TrigonometryDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    //alert(lat1 +":"+ lon1 + ":" + lat2 +":" + lon2);
    var R = 6371; // Radius of the earth in km
    var dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = this.deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    console.log(d);
    return d;
  }
  deg2rad(deg) {
    return deg * (Math.PI / 180)
  }
  async SetCustomerVerified(obj: any, isformupload: boolean) {
    return this.api.apiPost(false, `SalesLogin/UpdateVerified`, obj, isformupload);
  }

  GetCheckinCPanel_EnableDisable() {
    let _endis = false;
    let checkindata: any = { checkin: "", checkinout_datetime: "", expiry_datetime: "", }
    var retrievedLoginString: any = this.api.get_local_storage("sales_checkindata", true);
    if (retrievedLoginString != null && retrievedLoginString.checkin != null && retrievedLoginString.checkin != '' && retrievedLoginString.checkin != "0") {
      if (retrievedLoginString != null && retrievedLoginString.checkinout_datetime != null && retrievedLoginString.checkinout_datetime != '' &&
        retrievedLoginString.expiry_datetime != null && retrievedLoginString.expiry_datetime != '') {
        var currentDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        //var checkindatetime = moment(retrievedLoginString.checkinout_datetime).format(format1);
        var checkinExpirydatetime = moment(retrievedLoginString.expiry_datetime).format("YYYY-MM-DD HH:mm:ss");

        if (currentDateTime > checkinExpirydatetime) {
          this.api.set_local_remove_storage("sales_checkindata");
          _endis = false;
        }
        else {
          _endis = true;
        }
      }
    }
    else {
      _endis = false;
    }
    return _endis;
  }

  async UserCheckinCheckout() {
    let state: any = { location: "" }
    state.location = await this.getLocation();
    if (state.location.status == 1) {
      let userCheckinCheckoutValue = "0";
      let checkinID = "0";
      let checkindata: any = { checkin: "", checkinout_datetime: "", expiry_datetime: "", }
      let checkinValue; let checkinExpiryValue;
      var retrievedLoginString: any = this.api.get_local_storage("sales_checkindata", true);
      if (retrievedLoginString != null && retrievedLoginString.checkin != null && retrievedLoginString.checkin != '' && retrievedLoginString.checkin != "0") {
        userCheckinCheckoutValue = retrievedLoginString.checkin;
      }
      if (userCheckinCheckoutValue != null && userCheckinCheckoutValue != "0") {
        checkinID = userCheckinCheckoutValue;
      }
      var postdata = {
        Checkin_id: checkinID,
        "latitude": state.location.lat.toString(), "longitude": state.location.long.toString(), "url": environment.apiurl + this.router.url
      };
      console.log("postdata",postdata)
      this.api.loader.startLoading();
      await this.api.apiPost(false, `SalesLogin/UserCheckinCheckout`, postdata, false).then(data => {

        if (data && data != undefined && data != '[]') {

          if (data.checkin_checkout_flag == "1") //1 menas checkin done // 0 means checkout done
          {

            this.api.set_local_remove_storage("sales_checkindata", checkindata);
            checkindata.checkin = data.checkin_id;
            const format1 = "YYYY-MM-DD HH:mm:ss";
            if (data.checkinout_datetime != '' && data.checkinout_datetime != null) {
              checkinValue = moment(data.checkinout_datetime).format(format1);
              checkindata.checkinout_datetime = checkinValue;
              checkinExpiryValue = moment(data.checkinout_datetime).format(format1);
              var date = new Date(checkinExpiryValue);
              date.setHours(23);
              date.setMinutes(59);
              date.setSeconds(59);
              checkindata.expiry_datetime = moment(date).format(format1);
            } else {
              checkindata.checkinout_datetime = '';
              checkindata.expiry_datetime = '';
            }
            this.api.set_local_storage("sales_checkindata", checkindata);
          }
          else {
            this.api.set_local_remove_storage("sales_checkindata", checkindata);
            checkindata.checkin = "0";
            checkindata.checkinout_datetime = '';
            checkindata.expiry_datetime = '';
            this.api.set_local_storage("sales_checkindata", checkindata);

          }
        }
      })
      this.api.loader.stopLoading();
      return this.GetCheckinCPanel_EnableDisable();
    }
  }

  async UploadImage(customerid,files){
    let _url="";
    const formData: FormData = new FormData();
    formData.append('image', files[0], "screenshot.png");
    formData.append('customer_id',customerid);
    await this.api.apiPost(false, `SalesLogin/putfile`, formData, true).then(data => {
        console.log("data",data)
        if(data.status==1){
          _url=data.url;
        }
        this.api.loader.stopLoading();
    });
    return _url;
  }
}
